<div class="article-manager">
  <div class="table-operations">
    <div nz-row [nzGutter]="16" nzAlign="middle">
      <div nz-col [nzSpan]="6">
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" nz-input [(ngModel)]="searchKeyword" placeholder="搜索标题或摘要" (keyup.enter)="loadItems()" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" nzSearch (click)="loadItems()"><span nz-icon nzType="search"></span></button>
        </ng-template>
      </div>
      <div nz-col [nzSpan]="6">
        <nz-select [(ngModel)]="selectedSyllabusId" nzPlaceHolder="按分类筛选" (ngModelChange)="loadItems()" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let item of syllabusList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
        </nz-select>
      </div>
      <div nz-col [nzSpan]="12" style="text-align: right;">
        <button nz-button nzType="primary" (click)="openAdd()">发布点读包</button>
      </div>
    </div>
  </div>

  <nz-table
    #basicTable
    [nzData]="items"
    [nzLoading]="loading"
    nzTableLayout="fixed"
    [nzFrontPagination]="false"
    [nzTotal]="total"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
    (nzPageIndexChange)="onPageIndexChange($event)"
  >
    <thead>
      <tr>
        <th nzWidth="60px">ID</th>
        <th>标题</th>
        <th nzWidth="150px">分类</th>
        <th nzWidth="100px">封皮码</th>
        <th nzWidth="180px">页码</th>
        <th nzWidth="100px">版本</th>
        <th nzWidth="180px">创建时间</th>
        <th nzWidth="150px">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.id }}</td>
        <td nzEllipsis [nzTooltipTitle]="data.name" nz-tooltip>{{ data.name }}</td>
        <td>{{ data.syllabusName || '-' }}</td>
        <td>{{ data.coverOid }}</td>
        <td>{{ data.pageOidStart }} ~ {{ data.pageOidEnd }}</td>
        <td>{{ data.version }}</td>
        <td>{{ data.createdAt | date:'yyyy-MM-dd HH:mm' }}</td>
        <td>
          <a (click)="openEdit(data.id)">编辑</a>
          <nz-divider nzType="vertical"></nz-divider>
          <a class="delete-btn" (click)="deleteArticle(data.id)">删除</a>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- Article Edit Modal -->
  <nz-modal
    [nzBodyStyle]="{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }"
    [nzMaskClosable]="false"
    [nzWidth]="800"
    [nzVisible]="modalVisible"
    [nzTitle]="modalTitle"
    [nzFooter]="footerTpl"
    (nzOnCancel)="closeModal()"
  >
    <ng-container *nzModalContent>
      <form nz-form class="drawer-form" [formGroup]="validateForm" layout="vertical">
        <nz-form-item>
          <nz-form-label [nzSpan]="4" nzRequired>名称</nz-form-label>
          <nz-form-control [nzSpan]="420" nzErrorTip="请输入名称">
            <input nz-input formControlName="name" placeholder="请输入点读包名称" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4">所属分类</nz-form-label>
          <nz-form-control [nzSpan]="20">
            <nz-select formControlName="syllabusId" nzPlaceHolder="请选择分类" nzAllowClear>
              <nz-option *ngFor="let item of syllabusList" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4">简介</nz-form-label>
          <nz-form-control [nzSpan]="20">
            <textarea nz-input formControlName="summary" placeholder="点读包简介" [nzAutosize]="{ minRows: 2, maxRows: 4 }"></textarea>
          </nz-form-control>
        </nz-form-item>


        <!--
        <div nz-row [nzGutter]="16">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>标签</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="tagIds" nzMode="multiple" nzPlaceHolder="选择已有标签">
                  <nz-option *ngFor="let tag of availableTags" [nzValue]="tag.id" [nzLabel]="tag.name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label>新增标签</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="newTagNames" nzMode="tags" nzPlaceHolder="输入新标签，回车添加">
                  <nz-option *ngFor="let name of validateForm.get('newTagNames')?.value" [nzValue]="name" [nzLabel]="name"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        -->

            <nz-form-item>
              <nz-form-label [nzSpan]="4">封面</nz-form-label>
              <nz-form-control [nzSpan]="20">
                <div style="width: 350px">
                  <app-upload-image-with-preview-v2
                    [previewStyle]="{'background-size': 'cover'}"
                    [picUrl]="validateForm.get('cover')?.value"
                    (imageUploaded)="onCoverUploaded($event)"
                    [displayRatioWidth]="16"
                    [displayRatioHeight]="9"
                  ></app-upload-image-with-preview-v2>
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="4" nzRequired>上传点读包</nz-form-label>
              <nz-form-control [nzSpan]="20">
                <app-upload-file
                  [itemUrl]="this.validateForm.controls['url']?.value"
                  endsWith=".CMY"
                  accept=".CMY"
                  (itemSize)="updatePackageSize($event)"
                  (itemUploaded)="onPackageUploaded($event)"
                  (itemUploading)="onPackageUploading($event)"
                  [path]="'/oid-pen/packages/'"
                  [name]="validateForm.controls['url']?.value"
                ></app-upload-file>
                <nz-progress
                  *ngIf="packageUploading || packageUploadProgress > 0"
                  class="mt-2"
                  [nzPercent]="packageUploadProgress"
                  [nzStatus]="packageUploading ? 'active' : 'success'"
                  nzSize="small"
                ></nz-progress>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="4" nzRequired>封皮码</nz-form-label>
              <nz-form-control [nzSpan]="20">
                <nz-input-number formControlName="coverOid" name="seq" [nzMin]="0"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item>
              <nz-form-label [nzSpan]="4" nzRequired>内页码</nz-form-label>
              <nz-form-control [nzSpan]="20">
<!--                <nz-input-number-group *nzSpaceItem nzCompact>-->
                  <nz-input-number formControlName="pageOidStart" [nzStep]="1" style="width: 33%"></nz-input-number>
                ~
                  <nz-input-number formControlName="pageOidEnd" [nzStep]="1" style="width: 33%"></nz-input-number>
<!--                </nz-input-number-group>-->
              </nz-form-control>
            </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="4">关联书籍</nz-form-label>
          <nz-form-control [nzSpan]="20">
            <img *ngIf="relBookCover" [src]="relBookCover" class="w-16">{{relBookName}}
            <button nz-button style="margin-right: 8px;" (click)="openSelectBookDialog()">设置</button>
          </nz-form-control>
        </nz-form-item>

            <nz-form-item>
              <nz-form-label [nzSpan]="4">排序</nz-form-label>
              <nz-form-control [nzSpan]="20">
                <nz-input-number formControlName="seq" name="seq" [nzMin]="0"></nz-input-number>
              </nz-form-control>
            </nz-form-item>
      </form>
    </ng-container>

    <ng-template #footerTpl>
      <div>
        <button nz-button style="margin-right: 8px;" (click)="closeModal()">取消</button>
        <button nz-button nzType="primary" (click)="savePackageInfo()" [nzLoading]="loading">提交</button>
      </div>
    </ng-template>
  </nz-modal>
</div>




<ng-template #modalContent>
  <nz-spin [nzSpinning]="false">
    <app-admin-book-resource-courseware-list
      [resourceType]="'book'"
      [activeView]="'list'"
      [single]="true"
      [(itemSelection)]="bookSelection"></app-admin-book-resource-courseware-list>
  </nz-spin>
</ng-template>

<nz-modal
  [nzWidth]="'80%'"
  nzWrapClassName="v3"
  [nzKeyboard]="false"
  [nzMaskClosable]="false"
  [nzClosable]="true"
  [(nzVisible)]="showBookSelectDialog"
  [nzContent]="modalContent"
  [nzTitle]="'选择关联书籍'"
  [nzFooter]="null"
  (nzOnCancel)="closeBookSelectDialog()"
>


</nz-modal>

